var _excluded = ["icon", "className", "fontSize"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { Flex } from "../flex/Flex";
import Icons from "../../icons/IconList";
import classnames from 'classnames';
import "../../icons/static/font/neo-icons.css";
var SizeEnum = Object.freeze({
  xxLarge: 'xxLarge',
  xLarge: 'xLarge',
  large: 'large',
  medium: 'medium',
  small: 'small',
  xSmall: 'xSmall'
});
var sizeMap = {
  xxLarge: {
    fontSize: '32px'
  },
  xLarge: {
    fontSize: '24px'
  },
  large: {
    fontSize: '20px'
  },
  medium: {
    fontSize: '16px'
  },
  small: {
    fontSize: '12px'
  },
  xSmall: {
    fontSize: '10px'
  }
};

var sizes = function sizes(_ref) {
  var size = _ref.size;
  return sizeMap[size];
};

var getBaseIconStyle = function getBaseIconStyle(props) {
  return _objectSpread({
    borderRadius: 2,
    fontSize: 'inherit'
  }, sizes(props));
};

var Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var icon = props.icon,
      className = props.className,
      fontSize = props.fontSize,
      others = _objectWithoutProperties(props, _excluded);

  var iconClassName = icon && icon.getIconFontClass ? icon.getIconFontClass() : Icons[icon] && Icons[icon].getIconFontClass();

  if (!iconClassName) {
    return icon;
  }

  return /*#__PURE__*/React.createElement(Flex, _extends({
    _getBaseStyle: getBaseIconStyle,
    ref: ref,
    as: "i",
    display: "inline-flex",
    className: classnames(iconClassName, className),
    "data-test-id": "neo-icon-".concat(icon)
  }, others));
});
Icon.Icons = Icons;
Icon.Size = SizeEnum;
Icon.displayName = 'Icon';
export { Icon };
export default Icon;